<section class="panel p-4">
  <h2 class="h5 mb-3">Cadastro de usuarios</h2>
  <form class="row g-3" (ngSubmit)="salvarUsuario()">
    <app-seletor-usuario-existente
      [usuarios]="usuarios"
      [usuarioSelecionado]="usuarioSelecionado"
      (usuarioSelecionadoChange)="selecionarUsuario($event)">
    </app-seletor-usuario-existente>

    <app-painel-dados-usuario
      class="row g-3"
      [usuario]="usuario"
      [empregadores]="empregadores"
      [departamentos]="departamentos"
      [empregadorSelecionado]="empregadorSelecionado"
      (usuarioChange)="usuario = $event"
      (empregadorSelecionadoChange)="selecionarEmpregador($event)">
    </app-painel-dados-usuario>

    <div class="col-12">
      <app-rodape-crud
        [exibirExcluir]="true"
        [excluirDesabilitado]="!usuario.id"
        (excluir)="excluirUsuario()"
        (limpar)="limparUsuario()"
        (salvar)="salvarUsuario()">
      </app-rodape-crud>
    </div>
  </form>
</section>
